<template>
  <div class="tb-split-btn-wrapper" ref="wrapper">
    <button
      class="tb-btn tb-btn-contained medium-em"
      @click="onClick"
      :class="{'disabled': disabled }"
      :disabled="disabled"
    >
      <slot />
    </button>
    <button
      class="tb-btn tb-btn-contained medium-em"
      @click="toggleDropdown"
      :class="{'disabled': disabled }"
      :disabled="disabled"
    >
      {{ splitButtonLabel }}
      <span class="fas fa-chevron-right" />
    </button>
    <div
      v-if="showOptions"
      class="tb-split-btn__dropdown"
      :style="dropdownStyles"
    >
      <div
        v-for="option in options"
        :key="option.key"
        :class="option.divider ? 'tb-split-btn__dropdown-divider' : 'tb-split-btn__dropdown-option'"
      >
        <div v-if="!option.divider" @click="option.onClick">
          {{ option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TgbSplitButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Array,
      default: () => [],
    },

    splitButtonLabel: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.dimensions.width = this.$refs.wrapper.offsetWidth;
    this.dimensions.height = this.$refs.wrapper.offsetHeight;
  },

  beforeUnmount() {
    document.body.removeEventListener('mouseup', this.handleMouseUp);
  },

  data() {
    return {
      showOptions: false,
      dimensions: {
        width: 0,
        height: 0,
      },
    };
  },

  computed: {
    dropdownStyles() {
      const { height, width } = this.dimensions;

      // Magic
      return {
        transform: `translateY(calc(50% - ${height / 2}px))`,
        marginLeft: `${width}px`,
      };
    },
  },

  methods: {
    handleMouseUp() {
      // Just hide the options on any click
      setTimeout(() => {
        if (this.showOptions) {
          this.toggleDropdown();
        }
      });
    },

    onClick() {
      this.$emit('click');
    },

    toggleDropdown() {
      this.showOptions = !this.showOptions;

      if (this.showOptions) {
        document.body.addEventListener('mouseup', this.handleMouseUp);
      } else {
        document.body.removeEventListener('mouseup', this.handleMouseUp);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tb-split-btn-wrapper {
  display: flex;
  position: relative;
  align-items: center;
  height: 24px;

  .tb-btn:not(last-child) {
    margin-right: 2px;
  }

  .tb-btn:last-of-type {
    margin-left: 0;
    font-size: 1.1em;
    height: 32px;
    line-height: 0; /* fontawesome alignment workaround */
  }
}

.tb-split-btn__dropdown {
  /* TODO: Use vars for colors */
  position: fixed;
  max-height: 300px;
  max-width: 300px;
  min-width: 120px;
  font-size: 13px;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(#000000, .25);
  background-color: #272727;
  z-index: 2;
  overflow: auto;
  padding: 0.5rem 0;

  .tb-split-btn__dropdown-divider {
    display: block;
    width: auto;
    height: 1px;
    margin: 0.5rem;
    background: rgba(255,255,255,.12)
  }

  .tb-split-btn__dropdown-option {
    & > div {
      padding: 4px 6px;
      white-space: nowrap;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover {
      cursor: pointer;
      background: rgba(255, 255, 255, .04);
    }
  }
}
</style>
